var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fb259437-ef5e-492b-9f57-ff84c8354f22",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.7 16.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a4a1b55c-90bb-49c2-bfdb-844f54e33153",
    "data-name": "calendar-date"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "afa11cfa-19db-40b0-a1db-1f0d0ac794dc",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 1",
    className: "a1790112-06d8-4b2f-bf47-64cd7fc17a50",
    x: 1.95,
    y: 6.08,
    width: 4,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "a1ced815-f2f5-4aa8-867d-04a5da205b1f",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 2",
    className: "a1790112-06d8-4b2f-bf47-64cd7fc17a50",
    x: 5.95,
    y: 6.08,
    width: 4,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "e0a45bda-4fc2-41f4-a6eb-bad65365abdd",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 3",
    className: "a1790112-06d8-4b2f-bf47-64cd7fc17a50",
    x: 1.95,
    y: 10.08,
    width: 4,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "ba4b52ec-cdb4-46da-9443-bc548028fd69",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 4",
    className: "a1790112-06d8-4b2f-bf47-64cd7fc17a50",
    x: 5.95,
    y: 10.08,
    width: 4,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "f5223291-0d1e-4cc7-9ce1-4d04f39946b2",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 5",
    className: "a1790112-06d8-4b2f-bf47-64cd7fc17a50",
    x: 9.95,
    y: 6.08,
    width: 4,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "e9f312a1-68d5-4770-914d-915806b0390e",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 2",
    className: "f57c9e8e-3c4a-4e0b-995c-e7a30c07f1e4",
    d: "M16,2.17H12.52V.78a.7.7,0,0,0-1.39,0V2.17H5.57V.78A.7.7,0,0,0,4.17.62V2.17H.7a.7.7,0,0,0-.7.7H0V15.38a.7.7,0,0,0,.7.7H16a.7.7,0,0,0,.7-.7h0V2.86A.69.69,0,0,0,16,2.17Zm-.7,12.52H1.39V5H15.3Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.8c4a25301e5901e052ba4d9b4b1513b5.svg";
export { ForwardRef as ReactComponent };